import { ReactElement } from 'react'
import { useIfcSelection } from '@editorHooks'
import SelectionInfoRow from '../SelectionInfoRow'

interface Props {
  /**
   * When true, render a "no elements selected" row instead of nothing while the selection is empty,
   * so the panel layout stays stable (no jumping). Defaults to hiding when empty.
   */
  showWhenEmpty?: boolean
}

/**
 * Shows how many IFC elements are currently selected in the scene plus a button to clear the
 * selection. Renders nothing when nothing is selected unless `showWhenEmpty` is set. Shared by the
 * IFC Import step panels (filter, storey assignment, …).
 */
const IFCSelectionInfo = ({ showWhenEmpty = false }: Props): ReactElement | null => {
  const { selectedIfcElementGuids, setSelectedIfcElementGuids } = useIfcSelection()

  return (
    <SelectionInfoRow
      count={selectedIfcElementGuids.length}
      onClear={() => setSelectedIfcElementGuids([])}
      showWhenEmpty={showWhenEmpty}
      dataCy="btn-ifc-clear-selection"
    />
  )
}

export default IFCSelectionInfo
